/**
 * After firing a store redirect, watch for the visitor coming back to this page
 * (app not installed, store dismissed, bfcache restore) and send them to the
 * web destination instead of leaving them on a dead redirect page.
 */
export function addNavigationListenersForRedirectingToWebFallback(
  webUrl: string
) {
  let hasPageBeenHidden = false;

  const cleanup = () => {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    window.removeEventListener("pageshow", handlePageShow);
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      hasPageBeenHidden = true;
    } else if (document.visibilityState === "visible" && hasPageBeenHidden) {
      cleanup();
      window.location.replace(webUrl);
    }
  };

  const handlePageShow = (event: PageTransitionEvent) => {
    if (event.persisted) {
      cleanup();
      window.location.replace(webUrl);
    }
  };

  document.addEventListener("visibilitychange", handleVisibilityChange);
  window.addEventListener("pageshow", handlePageShow);
}
